import { PageHeader as PageHeaderUI } from "@business-finland/wif-ui-lib/dist/PageHeader";

export interface PageHeaderProps {
  heading: string;
  leadText?: string;
  backgroundColor: "blue" | "lightBlue";
}

export function PageHeader({
  heading,
  leadText,
  backgroundColor,
}: PageHeaderProps): JSX.Element {
  return (
    <div>
      <PageHeaderUI
        heading={heading}
        leadText={leadText}
        backgroundColor={backgroundColor}
      />
    </div>
  );
}
